import Head from 'next/head';

interface IFacebookProps {
  ogTitle: string;
  ogDesc: string;
  ogUrl: string;
  ogImageUrl: string;
  ogImageAlt: string;
  ogType: string;
  ogLocale: string;
  ogSiteName: string;
}

export default function Facebook({
  ogTitle,
  ogDesc,
  ogUrl,
  ogImageUrl,
  ogImageAlt,
  ogType,
  ogLocale,
  ogSiteName,
}: IFacebookProps) {
  return (
    <Head>
      <meta property="og:site_name" content={ogSiteName} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDesc} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:image:alt" content={ogImageAlt} />
    </Head>
  );
}
